import type { TransformMode } from '../core/types';
import {
  applyQuickTransform,
  setTransformMode,
  startFreeTransform,
  type QuickTransform,
} from '../tools/transform';

export const TRANSFORM_MODES: { mode: TransformMode; label: string }[] = [
  { mode: 'free', label: 'Scale and Rotate' },
  { mode: 'skew', label: 'Skew' },
  { mode: 'distort', label: 'Distort' },
  { mode: 'perspective', label: 'Perspective' },
  { mode: 'warp', label: 'Warp' },
];

export const QUICK_TRANSFORMS: { kind: QuickTransform; label: string }[] = [
  { kind: 'rotate180', label: 'Rotate 180°' },
  { kind: 'rotate90cw', label: 'Rotate 90° CW' },
  { kind: 'rotate90ccw', label: 'Rotate 90° CCW' },
  { kind: 'flipH', label: 'Flip Horizontal' },
  { kind: 'flipV', label: 'Flip Vertical' },
];

export function beginTransform(mode: TransformMode): void {
  setTransformMode(mode);
  startFreeTransform();
}

export { applyQuickTransform, startFreeTransform };
export type { QuickTransform };
